// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zVs0","questions":"styles_questions__2obFD","footer":"styles_footer__n8Cwk"};